module.exports = __webpack_public_path__ + "images/usd.d28f9fc813392ccf6d676578c6f930d8.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/flags/usd.png
// module id = 445
// module chunks = 0